import { toast } from "react-toastify";
import axiosClient from "./axiosClient";


// Get weeks with days and content 
export const getWeeksApi = async (params) => {
  try {
    const response = await axiosClient.get(`/user-service/education/week-with-days`, { params });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching adherence statistics.");
  }
};

// Add a new week
export const addWeekApi = async (weekData) => {
  try {
    const response = weekData?._id ? await axiosClient.put(`/user-service/education/week/${weekData._id}`, weekData) : await axiosClient.post(`/user-service/education/week`, weekData);

    if (response?.status === "SUCCESS") {
      toast.success(weekData?._id ? "Week updated successfully" : "Week added successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while adding the week.");
  }
};

//Delete a week
export const deleteWeekApi = async (weekId) => {
  try {
    const response = await axiosClient.delete(`/user-service/education/week/${weekId}`);
    if (response?.status === "SUCCESS") {
      toast.success("Week deleted successfully");

      return response;
    } else {
      toast.error(response.message);
      return response
    }
  } catch (err) {
    toast.error("An error occurred while deleting the week.");
  }
};

// update day 
export const updateDayApi = async (dayData) => {

  try {
    const response = await axiosClient.put(`/user-service/education/weeks/${dayData.weekId}/days/${dayData.dayId}`, dayData);
    if (response?.status === "SUCCESS") {
      toast.success("Day updated successfully");
      return response;
    } else {
      toast.error(response.message);
    }

  } catch (err) {
    toast.error("An error occurred while updating the day.");
  }
};

// get content for a specific week and day
export const getContentApi = async (weekId, dayId) => {
  try {
    const response = await axiosClient.get(`/user-service/education/week/${weekId}/day/${dayId}/content`);
    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching content.");
  }
}

// Add content for a specific week and day
export const addContentApi = async (content, isEditing) => {
  const contentId = content.get('contentId');
  try {
    const response = isEditing !== null ? await axiosClient.put(`/user-service/education/day/content/${contentId}`, content) : await axiosClient.post(`/user-service/education/day/content`, content);
    if (response?.status == "SUCCESS") {
      toast.success("Content added successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while adding content.");
  }
}

//delete content api 
export const deleteContentApi = async (contentId) => {
  try {
    const response = await axiosClient.delete(`/user-service/education/day/content/${contentId}`);
    if (response?.status === "SUCCESS") {
      toast.success("Content deleted successfully");
      return response;
    } else {
      toast.error(response.message);
      return response;
    }
  } catch (err) {
    toast.error("An error occurred while deleting the content.");
  }
};